export const resizeImage = (dataUrl, options = {}) => {
  return new Promise((resolve, reject) => {
    const {
      maxWidth = 600,
      maxHeight = 300,
      quality = 0.5,
      type = 'image/jpeg'
    } = options;

    // Create an image to load the data URL
    const img = new Image();
    img.src = dataUrl;

    img.onload = () => {
      // Create a canvas element
      const canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;

      // Calculate new dimensions
      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }
      if (height > maxHeight) {
        width = Math.round((width * maxHeight) / height);
        height = maxHeight;
      }

      // Set canvas dimensions
      canvas.width = width;
      canvas.height = height;

      // Draw resized image
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = 'white'; // Set white background
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);

      // Convert to data URL with compression
      const compressedDataUrl = canvas.toDataURL(type, quality);
      resolve(compressedDataUrl);
    };

    img.onerror = reject;
  });
}; 